import React from "react";
import { connect } from "react-redux";
import { signinActions } from "../../../actions";
import { mutedClick, emptyFunction } from "../../design/utilities";
import SignUpForm from "../../design/onboarding/SignUpForm";

class ConnectedSignUpForm extends React.Component {
  submitForm = event => {
    mutedClick(event);

    const {
      emailValue,
      passwordValue,
      repeatPasswordValue,
      subscribeToEmailsValue,
      t: { accountCreated }
    } = this.props;
    if (passwordValue === repeatPasswordValue) {
      this.props.submitSignup(
        emailValue,
        passwordValue,
        repeatPasswordValue,
        subscribeToEmailsValue,
        accountCreated
      );
    } else {
      this.props.setSignupError([this.props.passwordMatchErrorMsg]);
    }
  };


  onKeyUp = event => {
    if (event.key === "Enter") {
      this.submitForm(event);
    }
  };

  render() {
    return (
      <SignUpForm
        emailValue={this.props.emailValue}
        handleEmailChange={this.props.handleEmailChange}

        passwordValue={this.props.passwordValue}
        handlePasswordChange={this.props.handlePasswordChange}

        repeatPasswordValue={this.props.repeatPasswordValue}
        handleRepeatPasswordChange={this.props.handleRepeatPasswordChange}

        subscribeToEmailsValue = {this.props.subscribeToEmailsValue}
        toggleSubscribeToEmails = {this.props.toggleSubscribeToEmails}

        onSubmitClick={this.submitForm}

        tosPath={this.props.tosPath}
        privacyPath={this.props.privacyPath}

        onKeyUp={this.onKeyUp}
        errorMsg={this.props.errorMsg}
        t={this.props.t}
      />
    );
  }
}

const mapState = state => ({
  emailValue: state.signin.email,
  errorMsg: state.signin.errorSignUpMsg,
  passwordMatchErrorMsg: I18n.t("messages.password_match").toLowerCase(),
  passwordValue: state.signin.password,
  repeatPasswordValue: state.signin.repeatPassword,
  privacyPath: `${landing_host}${LanguageManager.langPath("privacy_policy")}`,
  subscribeToEmailsValue: state.signin.subscribeToEmails,
  tosPath: `${landing_host}${LanguageManager.langPath("terms_of_service")}`,
  t: I18n.t("components.signUpModal"),
  loggedInModalT: I18n.t("components.loggedInModal")
});

const mapDispatch = (dispatch, ownProps) => ({
  handleEmailChange: event => {
    dispatch(signinActions.setEmail(event.target.value));
  },
  handlePasswordChange: event => {
    dispatch(signinActions.setPassword(event.target.value));
  },
  handleRepeatPasswordChange: event => {
    dispatch(signinActions.setRepeatPassword(event.target.value));
  },
  toggleSubscribeToEmails: () => {
    dispatch(signinActions.toggleSubscribeToEmails());
  },
  setSignupError: errorMsg => {
    dispatch(signinActions.setSignupError(errorMsg));
  },
  submitSignup: (
    emailValue,
    passwordValue,
    repeatPasswordValue,
    subscribeToEmailsValue,
    successCreatedMsg
  ) => {
    dispatch(
      signinActions.submitSignup(
        emailValue,
        passwordValue,
        repeatPasswordValue,
        subscribeToEmailsValue,
        successCreatedMsg
      )
    );
  }
});

export default connect(mapState, mapDispatch)(ConnectedSignUpForm);
